import { ROUTES } from "../constants";

const buildAdminTabPath = (tab) => `${ROUTES.ADMIN}?tab=${tab}`;
const adminUsersPath = buildAdminTabPath("users");
const adminSitesPath = buildAdminTabPath("sites");
const adminRolesPath = buildAdminTabPath("roles");

const extractDataPath = (data = {}) => {
	if (!data) return null;
	const candidate =
		data.cta_path ||
		data.ctaPath ||
		data.path ||
		data.href ||
		data.url;
	if (typeof candidate === "string" && candidate.trim()) {
		return candidate.trim();
	}
	return null;
};

const buildOrderHistoryPathWithOrder = (notification = {}) => {
	let orderNumber = null;

	if (!orderNumber && notification.title) {
		const titleMatch = notification.title.match(/Order\s+Placed:\s*(.+?)$/i);
		if (titleMatch && titleMatch[1]) {
			orderNumber = titleMatch[1].trim();
		}
	}
	
	if (orderNumber) {
		return `${ROUTES.ORDER_HISTORY}?open_number=${encodeURIComponent(orderNumber)}`;
	}
	
	return ROUTES.ORDER_HISTORY;
};

const buildDocumentationTarget = (notification = {}) => {
	const data = notification.data || {};
	const siteId = data.site_id || data.siteId || data.site_id_fk || null;
	const machineNumber = data.machine_number || data.machineNumber || data.machine || null;
	const categoryName = data.category_name || data.categoryName || data.category || null;
	const documentId = data.document_id || data.documentId || null;
	const documentName = data.document_name || data.documentName || null;
	const ctaPath = extractDataPath(data);
	const params = new URLSearchParams();
	if (categoryName) params.set("category", categoryName);
	if (documentId) params.set("document_id", String(documentId));
	if (documentName) params.set("document_name", String(documentName));
	if (machineNumber) params.set("machine_number", String(machineNumber));
	const queryPath = params.toString() ? `${ROUTES.DOCUMENT}?${params.toString()}` : ROUTES.DOCUMENT;

	if (siteId || machineNumber || categoryName || documentId || documentName) {
		return {
			path: ctaPath || queryPath,
			siteId: siteId ? String(siteId) : null,
			machineNumber: machineNumber ? String(machineNumber) : null,
			categoryName: categoryName ? String(categoryName) : null,
			documentId: documentId ? String(documentId) : null,
			documentName: documentName ? String(documentName) : null,
			state: {
				machineNumber: machineNumber ? String(machineNumber) : null,
				siteId: siteId ? String(siteId) : null,
				categoryName: categoryName ? String(categoryName) : null,
				documentId: documentId ? String(documentId) : null,
				documentName: documentName ? String(documentName) : null,
				notificationScope: data.notification_scope || null,
			},
			requiresSiteSwitch: true,
		};
	}

	return ctaPath || ROUTES.DOCUMENT;
};
export const getNotificationNavigationTarget = (notification = {}) => {
	if (!notification) return null;

	const key = String(
		notification.event_key || notification.data?.event_key || ""
	).toUpperCase();
	if (!key) return null;

	if (key.includes("DOCUMENT")) {
		return buildDocumentationTarget(notification);
	}

	const directPath = extractDataPath(notification.data);
	if (directPath) return directPath;

	if (key.includes("REQUEST")) return ROUTES.REQUESTS;
	if (key.includes("ORDER") || key.includes("CART")) return buildOrderHistoryPathWithOrder(notification);
	if (key.includes("CUSTOMER_CARE") || key.includes("SUPPORT") || key.includes("CASE"))
		// || key.includes("CONTACT") // add if ccr page is available
		return ROUTES.SERVICES;
	if (key.includes("MACHINE")) return ROUTES.MACHINES;
	if (key.includes("PASSWORD") || key.includes("ACCOUNT")) return ROUTES.PROFILE;
	if (key.includes("SITE")) return adminSitesPath;
	if (key.includes("ROLE")) return adminRolesPath;
	if (key.includes("USER")) return adminUsersPath;
	if (key.includes("ADMIN")) return ROUTES.ADMIN;

	return null;
};
